export default __webpack_public_path__ + "static/media/SAS Alert Tone 1.5db72e7e.mp3";